import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import { colorLightPink, colorPink } from '../Styles/Colors';

const TableComp = ({
  columns = [],
  row = [],
  sorting = true,
  pagination = true,
  rowSelection = true,
  allSelect = true,
  cellRenderers = {},
  isEdit,
  isDelete,
  setSelect,
  onEdit,
  onDelete,
  multipleSelect=true
}) => {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(columns[0]?.id);
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
 
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = row.map((row) => row.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    if (multipleSelect) {
      // Multiple selection logic
      const selectedIndex = selected.indexOf(id);
      let newSelected = [];
  
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1),
        );
      }
      setSelect(newSelected)
      setSelected(newSelected);
    } else {
      // Single selection logic
      const newSelected = selected.includes(id) ? [] : [id];
      setSelected(newSelected);
      setSelect(newSelected)
    }
  };
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, row.length - page * rowsPerPage);

  const renderCell = (row, column) => {
    if (cellRenderers[column.id]) {
      return cellRenderers[column.id](row[column.id], row);
    }
    return row[column.id];
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: "none" }}>
      <TableContainer sx={{ boxShadow: "none", border: "none" }}>
        <Table stickyHeader  >
          <TableHead sx={{ boxShadow: "none" }}>
            <TableRow sx={{ boxShadow: "none", height: "40px" }}>
              {/* <TableCell padding="checkbox" sx={{ bgcolor: "#601350" ,color:"white"}}>
   
              </TableCell> */}
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  sx={{ bgcolor:"#601350",color:"white" }}
                  align={"left"}
                  style={{}}
                  sortDirection={sorting && orderBy === column.id ? order : false}
                >
                  {column?.IsSortable ? (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : 'asc'}
                      onClick={(event) => handleRequestSort(event, column.id)}
                    >
                      {column.label}

                    </TableSortLabel>
                  ) : (
                    column.label
                  )}
                </TableCell>
              ))}
              {(isEdit || isDelete) && <TableCell sx={{ bgcolor:"#601350",color:"white" }}>Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {row.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i) => {
              const isItemSelected = isSelected(row.id);
              const labelId = `enhanced-table-checkbox-${row.id}`;

              return (
                <TableRow

                  onClick={(event) => handleClick(event, row.id)}
                  role="checkbox"
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={row.id}

                  sx={{ bgcolor: i % 2 === 1 && "#EBEBEB", cursor: "pointer", height: "40px" }}
                >
         
                  {columns.map((column) => (
                    <TableCell key={column.id} align={"left"}>
                      {renderCell(row, column)}
                    </TableCell>
                  ))}
                  {(isEdit || isDelete) && (
                    <TableCell>
                      {isEdit && (
                        <IconButton onClick={() => onEdit(row)}>
                          <EditIcon />
                        </IconButton>
                      )}
                      {isDelete && (
                        <IconButton onClick={() => onDelete(row.id)}>
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
            {/* {emptyRows > 0 && (
              <TableRow style={{ height: 20 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )} */}
          </TableBody>
        </Table>
      </TableContainer>
      {/* {pagination && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={row.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )} */}
    </Paper>
  );
};



export default TableComp;
